export default __webpack_public_path__ + "static/new_relic_logo-350-142f8c6706e106ce59c8508a62dbeb92.png";